import React, { useEffect, useRef, useState } from "react";
import "./dashboardlayout.scss";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../../../components/Footer/Footer";
import Sidebar from "../../../components/Sidebar/Sidebar";
import Toolbar from "../../../components/Toolbar/Toolbar";
import { useFetchPartnerDetails } from "../../../hooks/partnerHook/usePartner";
import { useDispatch, useSelector } from "react-redux";
import {
  logInPartner,
  setProfilePercentage,
  updateCertificateData,
  updateEquipmentsData,
  updateExperienceData,
  updateLicenceData,
  updateServicesData,
} from "../../../store/Partner/partnerDataSlice";
import Role from "../../../pages/partner/DashboardForms/Role/Role";
import MySkills from "../../../pages/partner/DashboardForms/Skills/Skills";
import Notifications from "../../../components/Notifications/Notifications";
import { useFetchInitialSiteData } from "../../../hooks/siteData/useInitialSiteData";
import {
  setPartnerRoles,
  setPartnerSkills,
  setUserLanguages,
} from "../../../store/Partner/siteData";
import WebTemplates from "../../../components/WebTemplates/WebTemplates";
import { closeTemplates } from "../../../store/Partner/modalSlice";
import GoogleMapComponent from "../../../components/GoogleMap/GoogleMap";

import { openMaps } from "../../../store/Partner/modalSlice";

function DashboardLayout() {
  const { isPending, error, data: initialSiteData } = useFetchInitialSiteData();

  const {
    error: partnerError,
    isPending: partnerLoading,
    data: responseData,
  } = useFetchPartnerDetails();

  const [showSidebar, setShowSideBar] = useState(() => {
    return window.innerWidth >= 768;
  });

  const showRoles = useSelector((state) => state.modal.showRoles);
  const showSkills = useSelector((state) => state.modal.showSkills);
  const showNotification = useSelector((state) => state.modal.showNotification);
   const showGoogleMap = useSelector((state) => state.modal.showGoogleMap);

  const dispatch = useDispatch();

  useEffect(() => {
    if (initialSiteData) {
      console.log("Initial Site Data:", initialSiteData);
      dispatch(setPartnerRoles(initialSiteData.partnerRoles));
      dispatch(setPartnerSkills(initialSiteData.partnerSkills));
      dispatch(setUserLanguages(initialSiteData.userLanguages));
    }
  }, [initialSiteData]);

  useEffect(() => {
    if (responseData) {
      const {
        partner: {
          licence,
          equipment,
          certificate,
          experience,
          services,
          ...partnerData
        },
        ...userData
      } = responseData;

      const finalData = {
        ...userData,
        partner: partnerData,
      };

      dispatch(logInPartner(finalData));
      dispatch(updateEquipmentsData(equipment));
      dispatch(updateServicesData(services));
      dispatch(updateCertificateData(certificate));
      dispatch(updateLicenceData(licence));
      dispatch(updateExperienceData(experience));
    }
  }, [dispatch, responseData]);

   useEffect(()=>{
      setTimeout(()=>{
           if(!userDetails?.partner?.location)
          dispatch(openMaps());
      },4000);
    },[])

   
    
  
  const userDetails = useSelector((state) => state.partner.user);

  const [profileCompletionPercent, setProfileCompletionPercent] = useState(0);

  const equipmentsData = useSelector((state) => state.partner.equipments);
  const servicesData = useSelector((state) => state.partner.services);
  const certificatesData = useSelector((state) => state.partner.certificates);
  const licenceData = useSelector((state) => state.partner.licence);
  const experienceData = useSelector((state) => state.partner.experience);
  const showTemplates = useSelector((state) => state.modal.showTemplates);
  const location = useLocation();
  const dynamicContentRef = useRef(null);
  const calculateProfilePercent = () => {
    let requiredFields = 0;

    const fieldsToCheck = [
      userDetails.email,
      userDetails.profile_img,
      userDetails.partner?.kyc,
      userDetails.partner?.socialDetails,
      userDetails.partner?.roles?.length > 0,
      userDetails.partner?.skills?.length > 0,
      certificatesData.length > 0,
      equipmentsData.length > 0,
      licenceData.length > 0,
      experienceData.length > 0,
      servicesData.length > 0,
    ];

    requiredFields = fieldsToCheck.filter(Boolean).length;

    const percentageCompleted = (
      (requiredFields * 100) /
      fieldsToCheck.length
    ).toFixed(2);
    dispatch(setProfilePercentage(percentageCompleted));
  };

  useEffect(() => {
    if (
      userDetails &&
      equipmentsData &&
      servicesData &&
      certificatesData &&
      licenceData &&
      experienceData
    ) {
      calculateProfilePercent();
    }
  }, [
    userDetails,
    equipmentsData,
    servicesData,
    certificatesData,
    licenceData,
    experienceData,
  ]);

  const closeChooseTemplatecontainer = () => {
    dispatch(closeTemplates());
  };

  useEffect(() => {
    if (dynamicContentRef.current) {
      dynamicContentRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location]);

  if (partnerLoading || !userDetails) {
    return <h1>Loading...</h1>;
  }

  if (partnerError) {
    return <h1> Error! Please Refresh or Relogin!</h1>;
  }

  return (
    <>
      <div className="dashboard-layout">
        <div
          className={`dashboard-sidebar ${
            showSidebar ? "show-sidebar" : "hide-sidebar"
          }`}
        >
          <Sidebar setShowSideBar={setShowSideBar} userData={responseData} />
        </div>

        <div className="dashboard-content-wrapper">
          <div className="dashboard-toolbar">
            <Toolbar
              showSidebar={showSidebar}
              setShowSideBar={setShowSideBar}
              userData={responseData}
            />
          </div>
          <div className="dashboard-main-content" ref={dynamicContentRef}>
            <div className="dashboard-body">
              <Outlet />
            </div>
            <footer className="dashboard-footer">
              <Footer />
            </footer>
          </div>
        </div>
      </div>

      {showRoles && <Role />}

      {showSkills && <MySkills />}

      {showNotification && <Notifications />}

      {showTemplates && (
        <WebTemplates
          closeChooseTemplatecontainer={closeChooseTemplatecontainer}
        />
      )}
       {showGoogleMap && <GoogleMapComponent />}
       
    </>
  );
}

export default DashboardLayout;
